import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import * as Sentry from '@sentry/browser';
import { Observable, Subscription } from 'rxjs';
import { environment } from '../../../../environments/version';
import { uiHelper } from '../../../helpers/ui.helper';

import { BettingSlip } from '../bettingslip/bettingslip';
import { TournamentsService } from '../tournaments/services/tournaments.service';
import { LoginService } from './../login/services/login.service';
import { Router } from '@angular/router';
import { ElectronService } from 'ngx-electron';

declare let $;
declare let langCode;
declare let langId;
declare let langs;

declare let _sendChromeMessage: any;

export class CustomerUser {
    public UserName: string;
    public Balance: string;
    public IsLogged: boolean;
    public Symbol: string;
    public TerminalBalance: string;
    public TerminalId: string;
    public CustomerCardActiveControl: string;
    public CustomerCardMessage: string;
    public CurrentBalance: string;
    public IsAnonymousBet: number;
    public TerminalIsActive: number;
    public IsTerminal = 1; // Terminal mi Değil mi ?
    public ParentBranchId: string;
    public CustomerId: string;
    public QrCustomerId?: string;
}

@Injectable()
export class CoreService {
    public isLogged: boolean;
    public subClient: Subscription;
    public customerUser: CustomerUser = {
        UserName: 'Test',
        Balance: '',
        IsLogged: false,
        Symbol: '',
        TerminalBalance: '',
        TerminalId: '',
        CustomerCardActiveControl: '',
        CustomerCardMessage: '',
        CurrentBalance: '0',
        IsAnonymousBet: 0,
        TerminalIsActive: 0,
        IsTerminal: 1,
        ParentBranchId: '',
        CustomerId: '',
        QrCustomerId: '',
    };
    public tService: TournamentsService;
    public customerUserUpdateListener: EventEmitter<any> = new EventEmitter();
    public CreditVoucherVisible = 1;
    public CustomerCardIsActive = 0;
    public showOpenBetsVisible = 0;
    // loginService: LoginService;
    public openbetsButtonHeight = 0;

    private loginsUrl = '/Login/';
    private apisUrl = '/API/';
    private flagLoginFailed = false;
    private TERMINAL_CACHE_KEY = 'terminalDataCache';
    private loginControlEmitted = false;

    constructor(
        private loginService: LoginService,
        private http: HttpClient,
        private _uiHelper: uiHelper,
        public router: Router,
        private _ElectronService: ElectronService,
    ) {
        if (!this.isSecondScreen()) {
            // Emit login_control first; actual GetClient will run after a short delay
            this.configureClient();
        }
    }

    public isSecondScreen(): boolean {
        const url = window.location.href;
        return url.toLowerCase().includes('secondscreen');
    }
 
    

    public configureClient() {
        const comp = this as CoreService;

        if (!this.loginControlEmitted && this._uiHelper != undefined && !this._uiHelper.SecondScreenIsActive) {
            // Mark as emitted immediately to prevent multiple concurrent schedules
            this.loginControlEmitted = true;
            // Give Electron 6s to read deploy.json and send firstlogin
            setTimeout(() => {
                this._uiHelper.SendElectronMessage('electronListener', {
                    type: 'login_control',
                    login_status: 'false',
                });
                this.configureClient();
            }, 6000);
            return;
        }

        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded',
            }),
            observe: 'response' as 'body',
            responseType: 'text' as 'text',
        };

        this.http.get(this.loginsUrl + '/GetClient', options).subscribe(
            data => {
                const dataText = data && data['body'];

                if (dataText != null && dataText !== '') {
                    this.customerUser.UserName = dataText.split('|')[0];
                    this.customerUser.Balance = dataText.split('|')[1];
                    this.customerUser.TerminalBalance = dataText.split('|')[4];
                    this.customerUser.TerminalId = dataText.split('|')[5];
                    this.customerUser.Symbol = dataText.split('|')[2];
                    this.customerUser.CurrentBalance = dataText.split('|')[6];
                    this.customerUser.IsAnonymousBet = parseInt(dataText.split('|')[7], 10) || 0;
                    this.customerUser.IsTerminal = parseInt(dataText.split('|')[8], 10) || 0;
                    this.customerUser.ParentBranchId = dataText.split('|')[9];

                    this.customerUser.IsLogged = true;
                    this.isLogged = true;

                    

                    // Cache terminal data locally for future startups
                    try {
                        localStorage.setItem(this.TERMINAL_CACHE_KEY, JSON.stringify(this.customerUser));
                    } catch (e) {
                        console.warn('Failed to cache terminal data', e);
                    }

                    this.customerUserUpdateListener.emit(this.customerUser);
                    this._uiHelper.SendElectronMessage('electronListener', {
                        type: 'terminalData',
                        terminal: this.customerUser,
                        version: environment.version,
                    });

                    this.loginService.LoginState = 1;
                } else {
                    // Handle empty dataText: assume not logged in
                    this.customerUser.IsLogged = false;
                    this.isLogged = false;
                    this.loginService.LoginState = 0;
                    this.customerUserUpdateListener.emit(this.customerUser);

                    // Fallback: if we have cached terminal data, provide it to Electron
                    this.trySendCachedTerminalData();
                }
            },
            error => {
                //Can't login try to initialize
                console.warn('configureClient error', error);

                setTimeout(() => {
                    if (this._uiHelper != undefined && !this._uiHelper.SecondScreenIsActive) {
                        // Only attempt to serve cached terminal data to Electron
                        this.trySendCachedTerminalData();
                        this.flagLoginFailed = true;
                    }
                }, 6000);
            },
            () => {},
        );
    }

    private trySendCachedTerminalData() {
        try {
            const cached = localStorage.getItem(this.TERMINAL_CACHE_KEY);
            if (!cached) return;
            const parsed = JSON.parse(cached);
            if (!parsed || !parsed.TerminalId || parsed.TerminalId === '') return;

            // Update current snapshot to keep UI consistent
            this.customerUser = { ...this.customerUser, ...parsed };
            this.customerUserUpdateListener.emit(this.customerUser);

            // Send to Electron
            this._uiHelper.SendElectronMessage('electronListener', {
                type: 'terminalData',
                terminal: this.customerUser,
                version: environment.version,
            });
        } catch (e) {
            console.warn('Failed to send cached terminal data', e);
        }
    }

    public CustomerCardBalance(CustomerId) {
        const comp = this as CoreService;

        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded',
            }),
            observe: 'response' as 'body',
            responseType: 'text' as 'text',
        };

        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', $('input[name="__RequestVerificationToken"]').val());
        urlParams.append('CustomerId', CustomerId);
        const body = urlParams.toString();
        this.http
            .post(this.loginsUrl + 'CustomerCardBalance', body, options) // ...using post request
            .subscribe(
                data => {
                    // console.log(data.toString());
                    const dataText = data && data['body'] ? data['body'].toString() : '';

                    if (dataText !== '') {
                        comp._uiHelper.SetCustomerCardStatus(true);

                        comp.loginService.LoginState = 1;
                        comp.CreditVoucherVisible = 0;
                        comp.CustomerCardIsActive = 1;
                        comp.openbetsButtonHeight = 57;

                        this.customerUser.IsTerminal = 0;
                        this.customerUser.UserName = dataText.split('|')[0];
                        this.customerUser.Balance = dataText.split('|')[1];
                        this.customerUser.TerminalBalance = dataText.split('|')[4];
                        this.customerUser.TerminalId = dataText.split('|')[5];
                        this.customerUser.Symbol = dataText.split('|')[2];
                        this.customerUser.CustomerCardActiveControl = dataText.split('|')[6];
                        this.customerUser.CustomerCardMessage = dataText.split('|')[7];
                        this.customerUser.CurrentBalance = dataText.split('|')[8];

                        this.customerUser.IsLogged = true;
                        comp.isLogged = true;

                        this.customerUserUpdateListener.emit(this.customerUser);
                        // Bu Terminal in Müştersisi değil se Para Okuma Makinesini Kapat
                        if (comp.customerUser.CustomerCardActiveControl == '1') {
                            console.log(
                                '--haltmoneyreader --- disable --- Kart Takıldı --- Bu Terminal in Müştersisi değil --- PARA OKUMA KAPATILDI --',
                            );
                            // PARA OKUMA KAPATILDI
                            _sendChromeMessage({
                                command: 'haltmoneyreader',
                            });

                            comp._uiHelper.SendElectronMessage('electronListener', {
                                type: 'moneyReader_control',
                                money_reader_status: 'disable',
                            });
                        } else if (comp.customerUser.CustomerCardActiveControl == '0') {
                            if (
                                comp._uiHelper.terminalConfig.TemporaryBet == false ||
                                comp._uiHelper.terminalConfig.IsBetOn == false
                            ) {
                                // PARA OKUMA AÇILDI 04.04.2022
                                _sendChromeMessage({
                                    command: 'haltmoneyreader',
                                });

                                comp._uiHelper.SendElectronMessage('electronListener', {
                                    type: 'moneyReader_control',
                                    money_reader_status: 'enable',
                                });
                            }
                        } else if (comp.customerUser.CustomerCardActiveControl == '2') {
                            $('#Customer_Card_Message_Modal').modal('show');
                        }

                        comp.isLogged = true;

                        comp._uiHelper.SendElectronMessage('electronListener', {
                            type: 'terminalData',
                            terminal: comp.customerUser,
                            version: environment.version,
                        });
                    }
                },
                function(error) {
                    console.log('Error happened' + error);
                },
                function() {},
            );
    }

    public CustomerCardBalance2(CustomerId) {
        const comp = this as CoreService;

        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded',
            }),
            observe: 'response' as 'body',
        };

        const urlParams = new URLSearchParams();
        urlParams.append('__RequestVerificationToken', $('input[name="__RequestVerificationToken"]').val());
        urlParams.append('CustomerId', CustomerId);
        const body = urlParams.toString();
        this.http
            .post<any>(this.loginsUrl + 'CustomerCardBalance2', body, options) // ...using post request
            .toPromise()
            .then(
                data => {
                    // console.log('CustomerCardBalance2 : ', data.body);
                    if (data.body && data.body.ResultCode != 102) {
                        comp._uiHelper.SetCustomerCardStatus(true);

                        comp.loginService.LoginState = 1;
                        comp.CreditVoucherVisible = 0;
                        comp.CustomerCardIsActive = 1;
                        comp.openbetsButtonHeight = 57;
                        this.customerUser = {
                            ...this.customerUser,
                            UserName: data.body.UserName,
                            Balance: data.body.CardBalance,
                            IsLogged: false,
                            Symbol: data.body.Currency,
                            TerminalBalance: data.body.TerminalBalance,
                            TerminalId: data.body.BranchId,
                            CustomerCardActiveControl: data.body.CustomerCardActiveControl,
                            CustomerCardMessage: data.body.ResultMessage,
                            CurrentBalance: data.body.Balance,
                            IsAnonymousBet: 0,
                            TerminalIsActive: 0,
                            IsTerminal: 0,
                            ParentBranchId: '',
                            CustomerId: data.body.CustomerId_Encrypt,
                        };

                        this.customerUserUpdateListener.emit(this.customerUser);

                        // Bu Terminal in Müştersisi değil se Para Okuma Makinesini Kapat
                        if (comp.customerUser.CustomerCardActiveControl == '1') {
                            console.log(
                                '--haltmoneyreader --- disable --- Kart Takıldı --- Bu Terminal in Müştersisi değil --- PARA OKUMA KAPATILDI --',
                            );
                            // PARA OKUMA KAPATILDI
                            _sendChromeMessage({
                                command: 'haltmoneyreader',
                            });

                            comp._uiHelper.SendElectronMessage('electronListener', {
                                type: 'moneyReader_control',
                                money_reader_status: 'disable',
                            });
                        } else if (comp.customerUser.CustomerCardActiveControl == '0') {
                            if (
                                comp._uiHelper.terminalConfig.TemporaryBet == false ||
                                comp._uiHelper.terminalConfig.IsBetOn == false
                            ) {
                                // PARA OKUMA AÇILDI 04.04.2022
                                _sendChromeMessage({
                                    command: 'haltmoneyreader',
                                });

                                comp._uiHelper.SendElectronMessage('electronListener', {
                                    type: 'moneyReader_control',
                                    money_reader_status: 'enable',
                                });
                            }
                        } else if (comp.customerUser.CustomerCardActiveControl == '2') {
                            $('#Customer_Card_Message_Modal').modal('show');
                        }
                        comp.isLogged = true;
                        comp._uiHelper.SendElectronMessage('electronListener', {
                            type: 'terminalData',
                            terminal: comp.customerUser,
                            version: environment.version,
                        });
                    }
                },
                function(error) {
                    console.log('Error happened' + error);
                },
            );
    }
    public SignOutCard() {
        const comp = this as CoreService;

        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded',
            }),
            observe: 'response' as 'body',
            responseType: 'text' as 'text',
        };

        this.http.get(this.loginsUrl + '/SignOutCard', options).subscribe(
            data => {
                const dataText = data['body'].toString();

                if (data == '') {
                    console.log('??');
                } else {
                    comp.loginService.LoginState = 1;
                    comp.CreditVoucherVisible = 1;
                    comp.CustomerCardIsActive = 0;
                    comp.openbetsButtonHeight = 0;
                    comp.showOpenBetsVisible = 0;
                    this.customerUser.IsTerminal = 1;
                    // comp.tournamentsService.router.navigate(['/LiveBets']);

                    // console.log("##DATA____", data);
                    // console.log("##SPLIT__UserName", dataText.split('|')[0]);
                    // console.log("##SPLIT__Balance", dataText.split('|')[1]);
                    // console.log("##SPLIT__Symbol", dataText.split('|')[2]);
                    // console.log("##SPLIT__TerminalBalance", dataText.split('|')[4]);

                    this.customerUser.UserName = dataText.split('|')[0];
                    this.customerUser.Balance = dataText.split('|')[1];
                    this.customerUser.TerminalBalance = dataText.split('|')[4];
                    this.customerUser.TerminalId = dataText.split('|')[5];
                    this.customerUser.Symbol = dataText.split('|')[2];
                    this.customerUser.CustomerCardActiveControl = dataText.split('|')[6];
                    this.customerUser.CustomerCardMessage = dataText.split('|')[7];
                    this.customerUser.CurrentBalance = dataText.split('|')[4];

                    this.customerUserUpdateListener.emit(this.customerUser);
                    // comp.customerUser.IsLogged = true;
                    comp.isLogged = true;

                    // Geçici olarak kapatıldı. 26.07.2021
                    comp._uiHelper.SendElectronMessage('electronListener', {
                        type: 'terminalData',
                        terminal: comp.customerUser,
                        version: environment.version,
                    });

                    comp.configureClient();
                    // Kart Çıkarıldığında Anasayfa ya dönüyor.
                    comp.router.navigate(['/']);
                }
            },
            function(error) {
                console.log('Error happened' + error);
            },
            function() {},
        );
    }

    public setCurrentTournamentsService(srv) {
        this.tService = srv;
    }

    public refreshClient(tick) {
        const comp = this as CoreService;
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded',
            }),
            observe: 'response' as 'body',
            responseType: 'text' as 'text',
        };
        this.http.get(this.loginsUrl + '/GetClient', options).subscribe(
            data => {
                const dataText = data && data['body'];
                if (dataText == null || dataText === '') {
                    comp.customerUser.IsLogged = false;
                    comp.isLogged = false;
                    if (comp.subClient != undefined) {
                        comp.subClient.unsubscribe();
                    }
                } else {
                    comp.customerUser.Balance = dataText.split('|')[1];
                    comp.customerUser.UserName = dataText.split('|')[0];
                    comp.customerUser.IsLogged = true;
                    comp.isLogged = true;
                    // Translating
                }

                comp.customerUserUpdateListener.emit(comp.customerUser);
            },
            error => {
                if (error.name === 'HttpErrorResponse' && error.status === 0) {
                    // Request was cancelled, do nothing
                    return;
                }
                comp.customerUser.IsLogged = false;
                comp.isLogged = false;
                if (comp.subClient != undefined) {
                    comp.subClient.unsubscribe();
                }
                comp.customerUserUpdateListener.emit(comp.customerUser);
            },
            () => {},
        );

        if (this.tService) {
            this.tService.getCashoutSlip(1);
        }
    }

    // Cashout Screen Waiting Modal
    OpenCashoutWaitingModal() {
        $('#cashoutWaitingModal')
            .modal({
                detachable: false,
                closable: false,
            })
            .modal('show');

        //setTimeout(() => this.CloseCashoutWaitingModal(), 15000);
    }

    CloseCashoutWaitingModal() {
        //console.warn("CloseCashoutWaitingModal");
        this.GetCustomerCardBalance();
        $('#cashoutWaitingModal').modal('hide');
    }

    public GetCustomerCardBalance() {
        if (this.customerUser.CustomerId != '') {
            this.CustomerCardBalance2(this.customerUser.CustomerId);
        }
    }

    
}
